import { render } from "./MemberForm.vue?vue&type=template&id=38b5da22&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"

import "./MemberForm.vue?vue&type=style&index=0&id=38b5da22&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b5da22"]])

export default __exports__